export const VALAMAR_THEME = {
  primary: '#E8732A',
  primaryDark: '#C45E1A',
  primaryLight: '#FEF0E6',
  accentPeach: '#FEF3EC',
  background: '#FFFFFF',
  backgroundWarm: '#F9F6F2',
  text: '#1A1A1A',
  textMuted: '#5C5C5C',
  border: '#E8E0D8',
  collectionGold: '#C9A84C',
  diamantTeal: '#2A8BA8',
  headerDark: '#1A1A1A',
  fontFamily: "'Inter', 'Graphik', system-ui, sans-serif",
  claim: 'Holiday as you are',
};

export const PROPERTIES = [
  {
    id: 'pical-resort',
    name: 'Pical Resort, Valamar Collection',
    shortName: 'Pical Resort',
    stars: 5,
    brand: 'Valamar Collection',
    accent: '#C9A84C',
    tagline: 'Premium luxury on the Parenzana coast',
    image: 'https://images.valamar.com/hr/valamar-collection/pical-resort/hero.jpg',
  },
  {
    id: 'parentino-hotel',
    name: 'Valamar Parentino Hotel',
    shortName: 'Parentino Hotel',
    stars: 4,
    brand: 'Valamar Hotels & Resorts',
    accent: '#E8732A',
    tagline: 'Family seaside paradise near old town',
    image: 'https://images.valamar.com/hr/valamar-hotels/parentino-hotel/hero.jpg',
  },
  {
    id: 'diamant-hotel',
    name: 'Valamar Diamant Hotel',
    shortName: 'Diamant Hotel',
    stars: 4,
    brand: 'Valamar Hotels & Resorts',
    accent: '#2A8BA8',
    tagline: 'Sports, wellness & Aquamar water park',
    image: 'https://images.valamar.com/hr/valamar-hotels/diamant-hotel/hero.jpg',
  },
];

export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'hr', label: 'Hrvatski', flag: '🇭🇷' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
];

export const DEFAULT_GUEST_CONTEXT = {
  crm: {
    name: 'Maria Schmidt',
    loyaltyTier: 'none',
    previousStays: 'first_time',
    guestType: 'couple',
    interests: ['dining'],
    nationality: 'german',
  },
  pms: {
    stayStatus: 'day_1',
    roomType: 'standard',
    boardType: 'half_board',
    nights: 7,
    parkingBooked: false,
    spaPackageBooked: false,
  },
  conditions: {
    spaAvailability: 'available',
    weather: 'sunny',
    occupancy: 'normal',
    tonightsSpecialEnabled: true,
    tonightsSpecial: "Istrian wine pairing dinner at Harry's Piccolo — €85/person",
  },
};
